const API_URLs = {
  development: 'https://api-staging.tokenza.io/',
  // production: 'https://api.mixerdev.com/'
  production: 'https://api-staging.tokenza.io/'
}

export const API_URL = API_URLs[process.env.NODE_ENV];